(function () {
  var ZONE_DELIVERABLE = "deliverable";
  var ZONE_UNSUPPORTED = "unsupported";

  var sydneyMetro = new Set([
    2000, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016,
    2017, 2018, 2019,
    2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031,
    2032, 2033, 2034, 2035, 2036, 2037, 2038, 2039, 2040, 2041, 2042, 2043,
    2044, 2045, 2046, 2047, 2048, 2049, 2050, 2060, 2061, 2062, 2063, 2064,
    2065, 2066, 2067, 2068, 2069, 2070, 2071, 2072, 2073, 2074, 2075, 2076,
    2077, 2079, 2080, 2081, 2082, 2083, 2084, 2085, 2086, 2087, 2088, 2089,
    2090, 2091, 2092, 2093, 2094, 2095, 2096, 2097, 2098, 2099, 2100, 2101,
    2102, 2103, 2104, 2105, 2106, 2107, 2108, 2109, 2110, 2111, 2112, 2113,
    2114, 2115, 2116, 2117, 2118, 2119, 2120, 2121, 2122, 2123, 2124, 2125,
    2126, 2127, 2128, 2129, 2130, 2131, 2132, 2133, 2134, 2135, 2136, 2137,
    2138, 2139, 2140, 2141, 2142, 2143, 2144, 2145, 2146, 2147, 2148, 2149,
    2150, 2151, 2152, 2153, 2154, 2155, 2156, 2157, 2158, 2159, 2160, 2161,
    2162, 2163, 2164, 2165, 2166, 2167, 2168, 2170, 2171, 2172, 2173, 2174,
    2175, 2176,
    2177, 2178, 2179, 2180, 2182, 2183, 2184, 2186, 2187, 2188, 2189, 2190,
    2191, 2192, 2193, 2194, 2195, 2196, 2197, 2198, 2199, 2200, 2202, 2203,
    2204, 2205, 2206, 2207, 2208, 2209, 2210, 2211, 2212, 2213, 2214, 2215,
    2216, 2217, 2218, 2219, 2220, 2221, 2222, 2223, 2224, 2225, 2226, 2227,
    2228, 2229, 2230, 2231, 2232, 2233, 2234, 2555, 2556, 2557, 2558, 2559,
    2560, 2565, 2745, 2762, 2763, 2765, 2766, 2783,
  ]);

  var melbourneMetro = new Set([
    3000, 3001, 3002, 3003, 3004, 3005, 3006, 3007, 3008, 3009, 3010, 3011,
    3012, 3013, 3014, 3015, 3016, 3017, 3018, 3019, 3020, 3021, 3022, 3023,
    3024, 3025, 3026, 3027, 3028, 3029, 3030, 3031, 3032, 3033, 3034, 3035,
    3036, 3037, 3038, 3039, 3040, 3041, 3042, 3043, 3044, 3045, 3046, 3047,
    3048, 3049, 3050, 3051, 3052, 3053, 3054, 3055, 3056, 3057, 3058, 3059,
    3060, 3061, 3062, 3063, 3064, 3065, 3066, 3067, 3068, 3069, 3070, 3071,
    3072, 3073, 3074, 3075, 3076, 3077, 3078, 3079, 3080, 3081, 3082, 3083,
    3084, 3085, 3086, 3087, 3088, 3089, 3090, 3091, 3092, 3093, 3094, 3095,
    3096, 3097, 3098, 3099, 3100, 3101, 3102, 3103, 3104, 3105, 3106, 3107,
    3108, 3109, 3110, 3111, 3112, 3113, 3114, 3115, 3116, 3117, 3118, 3119,
    3120, 3121, 3122, 3123, 3124, 3125, 3126, 3127, 3128, 3129, 3130, 3131,
    3132, 3133, 3134, 3135, 3136, 3137, 3138, 3139, 3140, 3141, 3142, 3143,
    3144, 3145, 3146, 3147, 3148, 3149, 3150, 3151, 3152, 3153, 3154, 3155,
    3156, 3157, 3158, 3159, 3160, 3161, 3162, 3163, 3164, 3165, 3166, 3167,
    3168, 3169, 3170, 3171, 3172, 3173, 3174, 3175, 3176, 3177, 3178, 3179,
    3180, 3181, 3182, 3183, 3184, 3185, 3186, 3187, 3188, 3189, 3190, 3191,
    3192, 3193, 3194, 3195, 3196, 3197, 3198, 3199, 3200, 3201, 3202, 3203,
    3204, 3205, 3206, 3207, 3750, 3782, 3802, 3805, 3975, 3976, 3977,
  ]);

  var paidShipPostcodes = new Set([
    // Central Coast
    2250, 2251, 2256, 2257, 2258, 2259, 2260, 2261, 2262, 2263,
    // Blue Mountains
    2758, 2773, 2774, 2776, 2777, 2778, 2779, 2780, 2782, 2784, 2785,
    // Wollongong & Kiama
    2500, 2502, 2505, 2506, 2508, 2515, 2516, 2517, 2518, 2519, 2520, 2526,
    2527, 2528, 2529,
    // Maitland & Newcastle
    2264, 2265, 2267, 2268, 2278, 2280, 2281, 2282, 2283, 2284, 2285, 2286,
    2287, 2289, 2290, 2291, 2292, 2293, 2294, 2295, 2296, 2297, 2298, 2299,
    2300, 2302, 2303, 2304, 2305, 2306, 2307, 2308, 2315, 2316, 2317, 2318,
    2319, 2320, 2321, 2322, 2323, 2324, 2325, 2326, 2327, 2335,
    // Berry & Nowra
    2533, 2535, 2540, 2541,
    // Southern Highlands
    2570, 2571, 2572, 2573, 2574, 2575, 2576, 2577, 2578,
    // Canberra & ACT
    2600, 2602, 2604, 2605, 2606, 2607, 2609, 2611, 2614, 2615, 2617, 2619,
    2620, 2900, 2902, 2903, 2905, 2906, 2911, 2912, 2913, 2914,
    // VIC paid ship
    3214, 3215, 3216, 3217, 3218, 3219, 3220,
    // Brisbane (QLD) - same paid rule as Geelong (VIC)
    4000, 4005, 4006, 4007, 4008, 4010, 4011, 4012, 4013, 4014, 4017, 4018,
    4030, 4031, 4032, 4034, 4036, 4051, 4053, 4055, 4059, 4060, 4061, 4064,
    4065, 4070, 4101, 4102, 4103, 4110, 4113, 4114, 4115, 4151, 4152, 4153, 4160,
    4161, 4169, 4170, 4171, 4172, 4173, 4174, 4175, 4176, 4177, 4178, 4179,
  ]);

  function classifyPostcode(postcode) {
    var code = parseInt(postcode, 10);
    if (Number.isNaN(code)) return null;
    if (
      sydneyMetro.has(code) ||
      melbourneMetro.has(code) ||
      paidShipPostcodes.has(code)
    ) {
      return ZONE_DELIVERABLE;
    }
    return ZONE_UNSUPPORTED;
  }

  function init() {
    var modal = document.getElementById("PostcodeCheckerModal");
    if (!modal) return;

    var closeBtn = modal.querySelector(".pc-modal__close");
    var screens = modal.querySelectorAll(".pc-modal__screen");
    var input = modal.querySelector(".pc-modal__input");
    var checkBtn = modal.querySelector('[data-action="check"]');
    var doneBtns = modal.querySelectorAll('[data-action="done"]');
    var checkAnotherBtns = modal.querySelectorAll('[data-action="check-another"]');
    var errorEl = modal.querySelector(".pc-modal__error");

    function showScreen(name) {
      screens.forEach(function (s) {
        s.hidden = s.dataset.screen !== name;
      });
    }

    function openModal() {
      modal.style.display = "block";
      modal.setAttribute("aria-hidden", "false");
      showScreen("input");
      if (input) {
        input.value = "";
        setTimeout(function () {
          input.focus();
        }, 100);
      }
      if (errorEl) errorEl.textContent = "";
    }

    function closeModal() {
      modal.style.display = "none";
      modal.setAttribute("aria-hidden", "true");
    }

    function handleCheck() {
      var postcode = input ? input.value.trim() : "";
      if (!/^\d{4}$/.test(postcode)) {
        if (errorEl)
          errorEl.textContent =
            "Please enter a valid 4-digit Australian postcode";
        return;
      }
      if (errorEl) errorEl.textContent = "";

      var zone = classifyPostcode(postcode);
      if (zone === ZONE_DELIVERABLE) {
        showScreen("great");
      } else {
        showScreen("sorry");
      }
    }

    if (closeBtn) {
      closeBtn.addEventListener("click", closeModal);
    }

    if (checkBtn) {
      checkBtn.addEventListener("click", handleCheck);
    }

    doneBtns.forEach(function (btn) {
      btn.addEventListener("click", closeModal);
    });

    checkAnotherBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        showScreen("input");
        if (input) {
          input.value = "";
          setTimeout(function () {
            input.focus();
          }, 100);
        }
        if (errorEl) errorEl.textContent = "";
      });
    });

    if (input) {
      input.addEventListener("input", function () {
        var val = input.value.replace(/\D/g, "");
        if (val !== input.value) input.value = val;
        if (val.length > 4) input.value = val.substring(0, 4);
        if (errorEl) errorEl.textContent = "";
      });

      input.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
          e.preventDefault();
          handleCheck();
        }
      });
    }

    document.addEventListener("keydown", function (e) {
      if (
        e.key === "Escape" &&
        modal.getAttribute("aria-hidden") === "false"
      ) {
        closeModal();
      }
    });

    document.addEventListener("click", function (e) {
      var anchor = e.target.closest("a");
      if (!anchor) return;
      var isTopbar = anchor.closest(".topbar__text, .topbar");
      if (!isTopbar) return;
      var text = anchor.textContent.trim();
      var title = (anchor.getAttribute("title") || "").trim();
      if (text === "Check Now" || title === "Check Now") {
        e.preventDefault();
        openModal();
      }
    });

    window.PostcodeCheckerModal = { open: openModal, close: closeModal };
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
